import type { FC, ReactNode } from 'react';

export const getPromoVariant = <TProps>(shouldDisplay: boolean, aVariant: ReactNode, bVariant: ReactNode): FC<TProps> =>
  (shouldDisplay ? aVariant : bVariant) as FC<TProps>;
